/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const filterAvailability= document.querySelector('.collection__products .collection__sidebar__group:has(#filter-Availability-1)');  
  if(filterAvailability){
    filterAvailability.querySelector('input#filter-Availability-1').checked = true;    
  }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();